import React, { useContext, useEffect, useState } from 'react';
import {  Grid, Menu } from 'semantic-ui-react';
import history from '../../../History';
import { getAppearanceData } from '../../../hooks/useAppearance';
import AuthContext from '../../../contexts/AuthContext';

function Header() {

    const { auth } = useContext(AuthContext);

    const [logoImg, setLogoImg] = useState<string>("");
    const [fontColour, setFontColour] = useState<string>("");
    const [bgColour, setBgColour] = useState<string>("");

    useEffect(() => {
        async function getData() {
             let data = await getAppearanceData(auth);
 
             if (data) {
                 setLogoImg(data.logo)
                 setFontColour(data.fontColour)
                 setBgColour(data.backgroundColour);
             }
         }
         getData();
    }, [])

    const menuStyle = {
        backgroundColor: bgColour,
        color: fontColour,
        height: "65px",
        position: "relative",
        borderRadius: "0px !important"
    }

    return (
        <div>
            <Menu className="menu" borderless inverted size='large' id="menu" style={menuStyle}>
                <Grid id="nav-bar">
                    <Grid.Row className="computer only row" style={{ display: 'flex' }}>
                        <Menu.Menu position='left' style={{ marginRight: '0px !important', flexGrow: '2', display: 'flex' }}>
                        </Menu.Menu>

                        <Menu.Menu className="item" style={{ position: 'fixed', left: '43%', width: '200px', height: '6vh', padding: '5px', margin: 0 }}>
                            <img src={logoImg} style={{
                                marginLeft: "auto", marginRight: "auto", display: "block", position: 'fixed', left: '43%', height: '50px', top: '10px',  width:'240px',
                        }}  alt='FYB CM2WebShare Logo' />
                        </Menu.Menu>

                        <Menu.Menu position='right' style={{ marginLeft: '0px !important'}}>
                        </Menu.Menu>
                    </Grid.Row>

                    <Grid.Row className="tablet mobile only row">
                        <Menu.Menu position='left' style={{ marginRight: '0px !important', flexGrow: '2', display: 'flex' }}>
                        </Menu.Menu>
                        <a className="header item"><img src={logoImg} alt='FYB CM2WebShare Logo' style={{width:'auto', height:45}} /></a>
                    </Grid.Row>
                </Grid>
            </Menu>
        </div>
    );
}

export default Header;